import script from "./ConfigurationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationPage.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationPage.vue?vue&type=style&index=0&id=612ee2f0&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-612ee2f0"]])

export default __exports__